import { Box } from '@material-ui/core'
import React from 'react'
import { connect } from 'react-redux'

import FeedbackLink from '../components/home/FeedbackLink'
import { selectDateStart } from '../redux/modules/delivery'
import { isSelectedDeliveryDateActive } from '../redux/selectors/deliverySelectors'
import LayoutInnerPageFeatureFlag from '../layouts/LayoutInnerPageFeatureFlag'
import { selectOfficeAccounts } from '../redux/selectors/accountSelectors'
import { selectCateringStores } from '../redux/selectors/cateringStoreSelectors'
import HomePreferredLocation from '../components/home/HomePreferredLocation'
import HomeDialogs from '../components/home/HomeDialogs'
import HomeSnackbars from '../components/home/HomeSnackbars'
import HomeUnlockPreferredPricing from '../components/home/HomeUnlockPreferredPricing'
import FeatureFlagSidebar from '../components/home/FeatureFlagSidebar'
import MobileWidgetSkeleton from '../components/home/MobileWidgetSkeleton'
import ManageOrderCard from '../components/home/ManageOrderCard'
import DailyDeliverySection from '../components/home/DailyDeliverySection'
import CateringDeliverySection from '../components/home/CateringDeliverySection'
import ReserveDeliverySection from '../components/home/ReserveDeliverySection'

const PageHomeFeatureFlags = ({
  //props
  locationId,
  showManageOrder,
  sortedDeliveries,
  friendsOrdered,
  isDesktop,
  isScriptLoaded,
  isScriptLoadSucceed,

  // redux
  activationDate,
  selectDateStart,
  errorLoading,
  isLoadingDeliveries,
  isSelectedDayActive,
  selectedDate,
  offices,
  cateringStores,
  reserveStores,
  isLoadingCateringStores,
  errorLoadingCateringStores,
  isLoadingReserveStores,
  errorLoadingReserveStores,
  orderFeeAtLocationForUser,
}) => {
  return (
    <>
      <LayoutInnerPageFeatureFlag
        HeaderComponent={
          <>
            <MobileWidgetSkeleton
              isDesktop={isDesktop}
              loading={isLoadingDeliveries}
              WidgetComponent={FeatureFlagSidebar}
            />
          </>
        }
        MainComponent={
          <>
            {showManageOrder && (
              <Box marginBottom={3} marginTop={3}>
                <ManageOrderCard locationId={locationId} />
              </Box>
            )}
            <DailyDeliverySection
              showHeader={true}
              deliveries={sortedDeliveries}
              friendsOrdered={friendsOrdered}
              locationId={locationId}
              selectedDate={selectedDate}
              offices={offices}
              isSelectedDayActive={isSelectedDayActive}
              activationDate={activationDate}
              isLoadingDeliveries={isLoadingDeliveries}
              errorLoading={errorLoading}
            />

            <ReserveDeliverySection
              reserveStores={reserveStores}
              isLoadingReserveStores={isLoadingReserveStores}
              errorLoadingReserveStores={errorLoadingReserveStores}
              userOrderFee={orderFeeAtLocationForUser}
              locationId={locationId}
            />

            <CateringDeliverySection
              cateringStores={cateringStores}
              locationId={locationId}
              isLoadingCateringStores={isLoadingCateringStores}
              errorLoadingCateringStores={errorLoadingCateringStores}
            />

            {!isLoadingDeliveries && (
              <Box className="center-xs" marginTop={4} marginBottom={4}>
                <FeedbackLink />
              </Box>
            )}
          </>
        }
        SidebarComponent={
          <FeatureFlagSidebar
            selectDateStart={selectDateStart}
            locationId={locationId}
            selectedDate={selectedDate}
          />
        }
        RightSidebarComponents={
          isDesktop ? [() => <HomePreferredLocation />, () => <HomeUnlockPreferredPricing />] : []
        }
        headerContainerMaxWidth={false}
        hideSidebar="sm"
      />
      <HomeDialogs
        locationId={locationId}
        isScriptLoaded={isScriptLoaded}
        isScriptLoadSucceed={isScriptLoadSucceed}
      />
      <HomeSnackbars />
    </>
  )
}

const mapStateToProps = state => {
  const { isLoadingDeliveries, selectedDate, errorLoading } = state.delivery
  const { isLoadingCateringStores, errorLoadingCateringStores } = state.cateringStores
  const { isAuthenticated } = state.user
  const { location: { activationDate } = {} } = state.location
  const { orderFeeAtLocationForUser } = state.location
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const { isWebpSupported } = state.browser
  const offices = selectOfficeAccounts(state)
  const cateringStores = selectCateringStores(state)
  const { reserveStores, isLoadingReserveStores, errorLoadingReserveStores } = state.reserveStores

  return {
    activationDate,
    errorLoading,
    isAuthenticated,
    isLoadingDeliveries,
    isSelectedDayActive,
    isWebpSupported,
    selectedDate,
    offices,
    cateringStores,
    reserveStores,
    isLoadingCateringStores,
    errorLoadingCateringStores,
    isLoadingReserveStores,
    errorLoadingReserveStores,
    orderFeeAtLocationForUser,
  }
}

const mapDispatchToProps = {
  selectDateStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageHomeFeatureFlags)
